import { render, staticRenderFns } from "./RegisterExames.html?vue&type=template&id=f7c03552&external"
import script from "./RegisterExames.vue?vue&type=script&lang=js"
export * from "./RegisterExames.vue?vue&type=script&lang=js"
import style0 from "./RegisterExames.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports